// extracted by mini-css-extract-plugin
export var about__image = "about-module--about__image--NhMKg";
export var about__imageWrapper = "about-module--about__image-wrapper--u5n3H";
export var about__gradient = "about-module--about__gradient--ndbwX";
export var about__gradient_tablet = "about-module--about__gradient_tablet--abdkB";
export var about__gradient_mobile = "about-module--about__gradient_mobile--SGuIP";